import microApp from '@ecoflow/ef-micro';
import lifeCycles from '@/configu/lifecycles';

microApp.start({
    lifeCycles,
});
